import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSupabaseAuth } from "@/contexts/SupabaseAuthContext";
import { Loader2 } from "lucide-react";
import AdminSettingsDialog from "@/components/AdminSettingsDialog";
import AuthBanner from "@/components/auth/AuthBanner";
import AuthForm from "@/components/auth/AuthForm";
import AuthHeader from "@/components/auth/AuthHeader";
import { Button } from "@/components/ui/button";

const Auth = () => {
  const { isAuthenticated, loading, login } = useSupabaseAuth();
  const navigate = useNavigate();
  const [adminSettingsOpen, setAdminSettingsOpen] = useState(false);

  // TEMP: Auto-login shortcut for development/testing only
  // DELETE THIS BUTTON BEFORE PRODUCTION
  const handleTempLogin = async () => {
    const { error } = await login("raphael215.rp@gmail.com", "Atd42120657@A");
    if (!error) {
      navigate("/dashboard");
    }
  };
  // END TEMP

  // Redirect to dashboard if authenticated (side-effect)
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return null;
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-900 to-purple-600">
        <div className="text-center">
          <Loader2 className="mx-auto h-8 w-8 animate-spin text-white" />
          <p className="mt-4 text-white">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 to-purple-600">
      <div className="w-1/2 flex items-center justify-center">
        <AuthBanner />
      </div>
      
      <div className="w-1/2 flex items-center justify-center relative">
        <AuthHeader onSettingsClick={() => setAdminSettingsOpen(true)} />
        {/* TEMP: Auto-login shortcut for development/testing only */}
        {/* DELETE THIS BUTTON BEFORE PRODUCTION */}
        <Button
          className="absolute top-4 left-4 z-50 bg-yellow-400 hover:bg-yellow-500 text-black font-bold border-2 border-yellow-600"
          onClick={handleTempLogin}
        >
          DEV: Login as raphael215.rp@gmail.com
        </Button>
        {/* END TEMP */}
        <AuthForm />
      </div>
      
      <AdminSettingsDialog 
        open={adminSettingsOpen} 
        onOpenChange={setAdminSettingsOpen}
      />
    </div>
  );
};

export default Auth;
